import type { PopupBannerData } from '@/types/popup-banner.type';

/** 홈페이지 팝업 배너 데이터 */
// export const popupBannerData: PopupBannerData[] = [
//   {
//     id: '1',
//     href: '/event/retest-license-fee',
//     subtitle: '도로로 설치하고',
//     title: '재시험비 & 면허증 발급비',
//     description: '지원받자! 드라이빙존에서 책임져요!',
//     imageSrc: '/images/test_img.webp',
//   },
//   {
//     id: '2',
//     href: '/pricing',
//     subtitle: '배너 2',
//     title: '두 번째 배너입니다',
//     description: '테스트용 배너 콘텐츠',
//     imageSrc: '/images/test_img.webp',
//   },
//   {
//     id: '3',
//     href: '/about-us',
//     subtitle: '배너 3',
//     title: '세 번째 배너입니다',
//     description: '테스트용 배너 콘텐츠',
//     imageSrc: '/images/test_img.webp',
//   },
// ];
export const popupBannerData: PopupBannerData[] = [
  {
    id: '1',
    href: '/event/retest-license-fee',
    description: '도로로 설치하고 재시험비 & 면허증 발급비 지원 받자!',
    imageSrc: '/images/main/popup/retest-license-fee-popup.webp',
  },
];
